export * from "./nemmadi-logo.component";
